import { RefObject, useEffect } from 'react';
import { useScrollIntoView } from '@ff-os/shared-react/hooks/useScrollIntoView';

export const useScrollIntoViewOnCreated = (ref: RefObject<HTMLElement>, { when }: { when: boolean }) => {

    const scrollIntoView = useScrollIntoView(ref, { includeHidden: true });

    useEffect(() => {
        if (ref.current && when) {
            scrollIntoView();
        }
    }, [ref.current]); // eslint-disable-line react-hooks/exhaustive-deps
};